package com.mgacreative.hotel.shared.ui.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

@Composable
fun VisualDatePicker(
    initialDate: LocalDate?,
    onDateSelected: (LocalDate) -> Unit,
    onDismissRequest: () -> Unit
) {
    val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
    
    var viewYear by remember { mutableStateOf(initialDate?.year ?: today.year) }
    var viewMonth by remember { mutableStateOf(initialDate?.monthNumber ?: today.monthNumber) }

    val daysInMonth = when (viewMonth) {
        2 -> if (viewYear % 4 == 0 && (viewYear % 100 != 0 || viewYear % 400 == 0)) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }

    val firstDayOfMonth = LocalDate(viewYear, viewMonth, 1)
    val startDayOfWeek = firstDayOfMonth.dayOfWeek.ordinal + 1 // 1=Mon, 7=Sun
    val emptyCells = startDayOfWeek - 1

    val monthNames = listOf("Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık")

    AlertDialog(
        onDismissRequest = onDismissRequest,
        title = {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                IconButton(onClick = {
                    if (viewMonth == 1) {
                        viewMonth = 12
                        viewYear -= 1
                    } else {
                        viewMonth -= 1
                    }
                }) {
                    Text("<", fontWeight = FontWeight.Bold)
                }
                Text("${monthNames[viewMonth - 1]} $viewYear", style = MaterialTheme.typography.titleMedium)
                IconButton(onClick = {
                    if (viewMonth == 12) {
                        viewMonth = 1
                        viewYear += 1
                    } else {
                        viewMonth += 1
                    }
                }) {
                    Text(">", fontWeight = FontWeight.Bold)
                }
            }
        },
        text = {
            Column {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                    listOf("Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz").forEach { day ->
                        Text(day, modifier = Modifier.weight(1f), textAlign = TextAlign.Center, style = MaterialTheme.typography.labelSmall)
                    }
                }
                Spacer(modifier = Modifier.height(8.dp))
                
                // Calendar Grid
                val totalCells = emptyCells + daysInMonth
                val rows = (totalCells + 6) / 7
                
                for (row in 0 until rows) {
                    Row(modifier = Modifier.fillMaxWidth()) {
                        for (col in 0 until 7) {
                            val cellIndex = row * 7 + col
                            val dayNumber = cellIndex - emptyCells + 1
                            
                            if (cellIndex >= emptyCells && dayNumber <= daysInMonth) {
                                val isSelected = (initialDate?.year == viewYear && initialDate?.monthNumber == viewMonth && initialDate?.dayOfMonth == dayNumber)
                                Box(
                                    modifier = Modifier
                                        .weight(1f)
                                        .aspectRatio(1f)
                                        .padding(2.dp)
                                        .background(
                                            color = if (isSelected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.primaryContainer, 
                                            shape = MaterialTheme.shapes.small
                                        )
                                        .clickable {
                                            onDateSelected(LocalDate(viewYear, viewMonth, dayNumber))
                                        },
                                    contentAlignment = Alignment.Center
                                ) {
                                    Text(
                                        text = dayNumber.toString(), 
                                        color = if (isSelected) MaterialTheme.colorScheme.onPrimary else MaterialTheme.colorScheme.onPrimaryContainer,
                                        style = MaterialTheme.typography.bodyMedium
                                    )
                                }
                            } else {
                                Box(modifier = Modifier.weight(1f).aspectRatio(1f))
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            TextButton(onClick = onDismissRequest) {
                Text("İptal")
            }
        }
    )
}

// Helpers for dd/MM/yyyy display
fun LocalDate.formatTr(): String {
    val d = dayOfMonth.toString().padStart(2, '0')
    val m = monthNumber.toString().padStart(2, '0')
    return "$d/$m/$year"
}

fun String.toDisplayDate(): String {
    // yyyy-MM-dd -> dd/MM/yyyy
    val parts = this.split("-")
    if (parts.size == 3) {
        return "${parts[2]}/${parts[1]}/${parts[0]}"
    }
    return this
}

fun String.toIsoDateFromDisplay(): String {
    // dd/MM/yyyy -> yyyy-MM-dd
    val parts = this.split("/")
    if (parts.size == 3) {
        return "${parts[2]}-${parts[1]}-${parts[0]}"
    }
    return this
}
